import React, { useContext } from 'react'
import { partition } from 'lodash'
import { splitArrayDynamically } from 'utils/array'
import { WrapStudentParagraph, WrapWordsContent } from './Style'
import { PageFlip } from '.'
import { WordsContext } from './Words'

const Paragraph = (props) => {
    const { showCartoon, visibleType } = props
    const { words, comment } = useContext(WordsContext)

    const [title, body] = partition(words, word => word.word_def_fe_details?.is_title);

    let pages = splitArrayDynamically(body, "word_def_fe_details.new_page")
    pages = pages.slice().reverse();

    if (pages.length % 2) {
        pages.unshift([])
    }

    return (
        <WrapStudentParagraph>
            <WrapWordsContent>
                {pages?.length ? <PageFlip visibleType={visibleType} pages={pages} title={title} comment={comment} /> : null}
            </WrapWordsContent>
        </WrapStudentParagraph>
    )
}

export default Paragraph